'use strict';

$(document).ready(function () {
    require('./web-components/loginFormElement').init();
    require('./web-components/registerFormElement').init();
    require('./web-components/pwResetFormElement').init();
    require('./web-components/loginNavTabsElement').init();
    require('./web-components/oauthRegisterElement').init();
});
